import { ArrowRightIcon } from '@repo/atomic-components';
import { selectViewportPageIdForRestorePageIndexInStore, useAppSelector } from '@/store';

interface PagesMovedToastDetailProps {
  pageCount: number;
  onJumpToPage: () => void;
}

export function PagesMovedToastDetail({ pageCount, onJumpToPage }: PagesMovedToastDetailProps) {
  // Held until the sections refresh the move kicked off lands, so while it is
  // set every page index is stale and the jump would resolve to the old order.
  const isPageOrderStale = useAppSelector(selectViewportPageIdForRestorePageIndexInStore) !== null;

  return (
    <div className="flex flex-col items-start gap-2">
      <span>{`${pageCount} ${pageCount === 1 ? 'page' : 'pages'} moved to the selected section.`}</span>
      <button
        type="button"
        disabled={isPageOrderStale}
        onClick={onJumpToPage}
        className="flex cursor-pointer items-center gap-1 font-semibold underline-offset-2 hover:underline focus-visible:underline focus-visible:outline-none disabled:cursor-default disabled:opacity-60 disabled:hover:no-underline"
      >
        Jump to page
        <ArrowRightIcon width={14} height={14} />
      </button>
    </div>
  );
}
